import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL




export const getDashboardAPI = async (payload) => {
  try {
    const data = {
      pid: payload,
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/premium/company`,
      data,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const getLOBNetPremiumAPI = async (payload) => {
  try {
    const data = {
      pid: payload,
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/premium/LOB`,
      data,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const getEmployeeAPI = async (payload) => {
  try {
    const data = {
      pid: payload,
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/Employee-graph`,
      data,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}



export const getCompanyGraphAPI = async (payload) => {
  try {
    const data = {
      pid: payload,
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/graph/company`,
      data,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error in Company Graph:", error)
    throw error
  }
}



export const getLOBGraphAPI = async (payload) => {
  try {
    const data = {
      pid: payload,
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/graph/LOB`,
      data,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error in LOB Graph:", error)
    throw error
  }
}